import type { AriaDatapointType } from "owa-analytics-types";
import { qosEvents } from "owa-analytics-events/lib/event-types-restricted/qosEvents";

export default function isQosDatapoint(datapoint: AriaDatapointType): boolean {
    return (!!datapoint?.getData("EventName") &&
        qosEvents.indexOf(datapoint.getData("EventName") as string) > -1);
}
